import { Injectable, signal } from "@angular/core";
import type { AgentIdleState } from "../../model/agent.types";
import { CHAT_IDLE_DEFAULTS } from "./chat-idle-config.token";

/**
 * Scoped signal bridge so ChatIdleStateComponent can reactively read the active
 * agent's idle config even when the user switches agents without recreating the container.
 * Provided at ChatContainerComponent level and updated via an effect there.
 */
@Injectable()
export class ChatIdleConfigBridge {
  readonly config = signal<Required<AgentIdleState>>({ ...CHAT_IDLE_DEFAULTS });
}
